import MenuItem from "@Components/Header/MenuItem";
import { COMPONENTS_CATEGORY, EVENT_LABEL, PAGE } from "constants/index";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import classes from "./ProductsDropdown.module.scss";
import AmberFlexIcon from "@Icons/AmberFlexIcon";
import AmberConnectIcon from "@Icons/AmberConnectIcon";
import AmberRedIcon from "@Icons/AmberRedIcon";
import wrapperHOC from "@Utils/wrapperHOC";

const ProductsDropdown = () => {
  const handleEventEmitter = ({ action, label = "", ...rest }: any) => {
    gtagEventEmitter({
      action,
      category: COMPONENTS_CATEGORY.TOP_NAV,
      label: `${PAGE.SEARCH} ${label}`,
      ...rest,
    });
  };

  return (
    <div className={classes.subMenu}>
      <div className={classes.products}>
        <MenuItem label="Dashboard" icon={<AmberRedIcon />} redirectTo="/dashboard" isDesktop />
        <div className={classes.separator} />
        <MenuItem
          label="Amber Flex"
          icon={<AmberFlexIcon />}
          redirectTo="/partner"
          clickHandler={() => handleEventEmitter({ action: EVENT_LABEL.AMBER_FLEX_CLICKED })}
          isDesktop
        />
        <MenuItem
          label="Amber Connect"
          icon={<AmberConnectIcon />}
          redirectTo="/connect"
          clickHandler={() => handleEventEmitter({ action: EVENT_LABEL.AMBER_CONNECT_CLICKED })}
          isDesktop
        />
      </div>
    </div>
  );
};

export default wrapperHOC(ProductsDropdown, {
  componentName: "ProductsDropdown",
  showForChina: true,
});
